
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.732 7.962v11.11H1.033V7.962h3.699zm.235-3.43c.011 1.065-.796 1.917-2.085 1.917H2.86c-1.244 0-2.04-.852-2.04-1.917 0-1.087.83-1.917 2.085-1.917 1.267 0 2.051.83 2.063 1.917zm13.071 8.172v6.368H14.35v-5.941c0-1.491-.538-2.511-1.872-2.511-1.02 0-1.625.684-1.895 1.345-.09.247-.123.572-.123.908v6.199H6.772c.045-10.067 0-11.11 0-11.11h3.688v1.614h-.022c.482-.762 1.356-1.872 3.352-1.872 2.433 0 4.249 1.592 4.249 5z"}})])
          )
        }
      }
    